// ReSharper disable VariableUsedInInnerScopeBeforeDeclared
(function (w, $, _) {
    var paymentIdDataKey = 'payment-id';

    const assetId = 'checkout4';
    const cookie = w.cms && w.cms.cookie ? w.cms.cookie : $.cookie;

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        return;
    }

    const ctx = w.umwAssets[assetId][0];

    var jQit = function (id) { return $('#UC' + ctx.controlId + '_' + id); };

    // #region Common variables
    var $container = $('#UC' + ctx.controlId);
    var $drpCountry = jQit('drpCountry');
    var $txbPostalCode = jQit('txbPostalCode');
    var $divCantChangePostalCodeMsg = jQit('divCantChangePostalCodeMsg');
    var $txbComment = jQit('txbComment');
    var $lbPostalArea;
    var $divDeliveryOptions = jQit('divDeliveryOptions');
    var $divPaymentContainer = jQit('divPaymentContainer');
    var $liPaymentTabHeaders = $divPaymentContainer.find('ul.js-payment-tab-headers li');
    var $divWritePostalCodeMsg = jQit('divWritePostalCodeMsg');
    var $divUndeliverableProdsMsg = jQit('divUndeliverableProdsMsg');
    var $divNoAvailableOptions = jQit('divNoAvailableOptions');
    var $divDeliveryDate = $container.find('div.DeliveryDate');
    var $txbDeliveryDate = jQit('txbDeliveryDate');
    var $deliveryDateImage = jQit('imgDeliveryDate');
    var $txbDeliveryDeadline = jQit('txbDeliveryDeadline');
    var $deliveryDeadlineImage = jQit('imgDeliveryDeadline');
    var $drpReferralGroup = jQit('drpReferralGroup');
    var $lblReferralGroup = jQit('lblReferralGroup');
    var $drpReferralName = jQit('drpReferralName');
    var $lblReferralName = jQit('lblReferralName');
    var $commentCont = $container.find('.js-comment-cont');

    var deliveryAddress = { isDeliverable: true };
    var estore = w.PublicEStore;
    var cartEmptyNoty;
    var selectedDeliveryId = -1;
    var isDateRequiredBySelectedDelivery = false;
    var blockInterfaceCounter = 0;
    var commentChangeTimeout = null;
    var checkoutSettings = {};
    // #endregion Common variables

    var postCodeChangeTimer;

    var checkoutController, deliveryOptionsController;
    var checkoutsCount = 0;
    var currentCheckoutSpecifics = null;
    const deliveryOptionsLoadInitiator = { checkoutOrder: 'checkoutOrder', pageLoad: 'pageLoad', userInput: 'userInput'};

    $(function() {
        if (w.checkoutController && w.deliveryOptionsController) {
            init();
        } else {
            var waitForLoadToken = setInterval(function() {
                if (w.checkoutController && w.deliveryOptionsController) {
                    w.clearInterval(waitForLoadToken);
                    init();
                }
            }, 100);
        }
    });

    var init = function() {
        if ($.blockUI) {
            $.blockUI.defaults.message = '<img src="' + ctx.R + 'SysImages/big-roller.gif" alt="Loading..." />';
        }
        if ($liPaymentTabHeaders.length == 0) {
            setNoPaymentAvailable();
            return;
        }

        checkoutController = w.checkoutController;

        checkoutSettings = {
            isDeliveryDateRequired: $txbDeliveryDate.length === 1,
            isDeliveryPostalCodeReadonly: $txbPostalCode.length === 1,
            checkouts: {},
            initializedPaymentRefId: ctx.initializedPaymentRefId,
            initializedPaymentMethodId: ctx.initializedPaymentMethodId,
            initializedCheckoutOrder: ctx.initializedCheckoutOrder,
            onCheckoutAvailable: function(paymentId, checkoutSpecifics, initializedCheckoutOrder) {
                currentCheckoutSpecifics = checkoutSpecifics;
                hidePaymentError(paymentId);

                var updatedDeliveryAddress = initializedCheckoutOrder.deliveryAddress;

                if (!updatedDeliveryAddress || !deliveryAddress || _.isEmpty(deliveryAddress))
                    return;

                var countryChanged = false, postalCodeChanged = false;

                if (updatedDeliveryAddress.countryCode &&
                    updatedDeliveryAddress.countryCode !== deliveryAddress.countryCode) {
                    if ($drpCountry) {
                        $drpCountry.val(deliveryAddress.countryCode);
                    }
                    deliveryAddress.countryCode = updatedDeliveryAddress.countryCode;
                    countryChanged = true;
                    onCountryCodeChanged();
                }

                if (updatedDeliveryAddress.postalCode &&
                    updatedDeliveryAddress.postalCode !== deliveryAddress.postalCode) {
                    deliveryAddress.postalCode = updatedDeliveryAddress.postalCode.trim();
                    deliveryAddress.postalArea = updatedDeliveryAddress.postalArea;
                    postalCodeChanged = true;
                } else if (countryChanged) {
                    deliveryAddress.postalCode = deliveryAddress.postalArea = null;
                    postalCodeChanged = true;
                }

                if ($txbPostalCode.length === 1) {
                    //const enableDeliveryPostalCode = checkoutSpecifics.canDisableDeliveryPostalCode === true;
                    // It was decided to not disable postal code input. Instead we'll reset the order in payment provider if it can't update with our postal code
                    const enableDeliveryPostalCode = true;
                    $txbPostalCode.prop('disabled', !enableDeliveryPostalCode);
                    if (enableDeliveryPostalCode) {
                        $divCantChangePostalCodeMsg.hide();
                    } else {
                        let cantChangePostalCodeMsg = $divCantChangePostalCodeMsg.data('msg-template');
                        if (cantChangePostalCodeMsg) {
                            if (checkoutSpecifics.name) {
                                cantChangePostalCodeMsg =
                                    cantChangePostalCodeMsg.replace('[CHECKOUT]', checkoutSpecifics.name);
                            }
                            $divCantChangePostalCodeMsg.text(cantChangePostalCodeMsg);
                            $divCantChangePostalCodeMsg.show();
                        }
                    }
                }

                if (postalCodeChanged) {
                    onPostalCodeChanged(true,
                        function() {
                            deliveryOptionsController.setDeliveryAddress(deliveryAddress,
                                deliveryOptionsLoadInitiator.checkoutOrder);
                        });
                } else if (countryChanged) {
                    deliveryOptionsController.setDeliveryAddress(deliveryAddress,
                        deliveryOptionsLoadInitiator.checkoutOrder);
                }
            },
            onCheckoutUnavailable: function(paymentId, reasonMsg) {
                currentCheckoutSpecifics = null;

                if (!w.PubSub || !reasonMsg) {
                    return ':`(';
                }

                showPaymentError(paymentId, reasonMsg);

                return '';
            },
            blockUi: function() { block($container); },
            unBlockUi: function() { unblock($container); },
        };

        var $checkouts = $container.find('[data-checkout-provider]');
        $checkouts.each(function(i, checkout) {
            var $checkout = $(checkout);
            var $errorCont = $checkout.find('.js-checkout-error');
            var $uiCont = $checkout.find('.js-checkout-ui');
            var paymentId = $checkout.data(paymentIdDataKey);
            var providerName = $checkout.data('checkout-provider');
            checkoutSettings.checkouts[paymentId] = {
                $errorCont: $errorCont,
                $uiCont: $uiCont,
                paymentId: paymentId,
                providerName: providerName
            };
            checkoutsCount++;
        });

        checkoutController.init(checkoutSettings);

        deliveryOptionsController = w.deliveryOptionsController;
        let deliveryOptionsEverAvailable = false;

        var deliverySettings = {
            $container: $divDeliveryOptions,
            controlId: ctx.controlId,
            R: ctx.R,
            checkoutStepNumber: ctx.checkoutStepNumber,
            preferredDeliveryMethodId: cookie('DeliveryID'),
            onDeliveryOptionsAvailable: function() {
                $divNoAvailableOptions.hide();
                $divUndeliverableProdsMsg.hide();
                deliveryOptionsEverAvailable = true;
            },
            onDeliveryOptionSelected: function(delivery) {
                setDelivery(delivery);
            },
            onNoDeliveryOptionAvailable: function(msg, initiator) {
                setDelivery(null);

                if (initiator === deliveryOptionsLoadInitiator.checkoutOrder && deliveryOptionsEverAvailable) {
                    checkoutController.resetOrderInProviderOnNextUpdate();
                }

                if (msg) {
                    if (msg === deliveryOptionsController.undeliverableMsg) {
                        $divNoAvailableOptions.hide();
                        $divUndeliverableProdsMsg.show();
                    } else if (msg !== deliveryOptionsController.missingInputsMsg) {
                        $divNoAvailableOptions.show();
                        $divUndeliverableProdsMsg.hide();
                        error(msg);
                    }
                } else {
                    $divNoAvailableOptions.show();
                    $divUndeliverableProdsMsg.hide();
                }
            },
            blockUi: function() { block($container); },
            unBlockUi: function() { unblock($container); }
        };

        deliveryOptionsController.init(deliverySettings);

        $txbDeliveryDate.attr('readonly', 'readonly');
        $txbDeliveryDate.datepicker({
            firstDay: 1,
            showWeek: false,
            changeMonth: true,
            changeYear: true,
            minDate: 0
        });

        $txbDeliveryDate.change(function() {
            const deliveryDate = getDeliveryDate();

            if (deliveryOptionsController.setDeliveryDate && typeof deliveryOptionsController.setDeliveryDate === 'function') {
                deliveryOptionsController.setDeliveryDate(deliveryDate, deliveryOptionsLoadInitiator.userInput).then(
                    () => {
                        checkoutController.setDeliveryDate(deliveryDate);
                    });
            } else {
                checkoutController.setDeliveryDate(deliveryDate);
            }

            if ($txbDeliveryDeadline.length) {
                const minDeadlineDate = deliveryDate ? new Date(deliveryDate) : 0;
                $txbDeliveryDeadline.datepicker('option', 'minDate', minDeadlineDate);
                $txbDeliveryDeadline.datepicker('refresh');
            }

            hidePaymentPanelIfDeliveryDateIsMissing();
        });
        checkoutController.setDeliveryDate(getDeliveryDate());

        $deliveryDateImage.click(function() { $txbDeliveryDate.focus(); });

        $divDeliveryDate.hide();

        (function setupDeliveryDeadlineSelector() {
            if (!$txbDeliveryDeadline.length) {
                return;
            }
            $txbDeliveryDeadline.attr('readonly', 'readonly');
            $txbDeliveryDeadline.datepicker({
                firstDay: 1,
                showWeek: false,
                changeMonth: true,
                changeYear: true,
                minDate: 0
            });
            $deliveryDeadlineImage.click(function () { $txbDeliveryDeadline.focus(); });
            $txbDeliveryDeadline.change(function () {
                const date = $txbDeliveryDeadline.datepicker('getDate');
                const dateStr = date ? date.toISOString() : null;

                checkoutController.setDeliveryDeadline(dateStr);
            });
        })();

        var selectedPaymentPanelIdx;
        if (ctx.initializedPaymentMethodId) {
            selectedPaymentPanelIdx = getPaymentIdxById(ctx.initializedPaymentMethodId) || 0;
        } else {
            selectedPaymentPanelIdx = parseInt(getPaymentIdxFromCookie());
            if (selectedPaymentPanelIdx >= $liPaymentTabHeaders.length) {
                selectedPaymentPanelIdx = 0;
            }
        }

        $divPaymentContainer.tabs({
            active: selectedPaymentPanelIdx,
            beforeActivate: function(event, ui) {
                var newTabIndex = ui.newTab.index();
                if (newTabIndex > -1) {
                    setPaymentIdxCookie(newTabIndex);

                    var paymentId = ui.newPanel.data(paymentIdDataKey);
                    checkoutController.selectCheckout(paymentId, deliveryAddress);
                    publishPaymentSelectedNotification(newTabIndex);
                }
            }
        });

        var selectedPaymentId = getSelectedPaymentId(selectedPaymentPanelIdx);
        checkoutController.selectCheckout(selectedPaymentId);
        publishPaymentSelectedNotification(selectedPaymentPanelIdx);

        addCommentChangeListeners();

        $lbPostalArea = $('<span class="PostalArea"></span>').insertAfter($txbPostalCode);

        deliveryAddress.countryCode = getCountryCodeFromCookie();
        if (!deliveryAddress.countryCode) {
            deliveryAddress.countryCode = ctx.countryCode;
        }

        deliveryAddress.postalCode = getPostalCodeFromCookie();
        if (!deliveryAddress.postalCode) {
            deliveryAddress.postalCode = ctx.postalCode;
        }

        if ($drpCountry && $drpCountry.length > 0) {
            addCountryChangeListeners();

            if (deliveryAddress.countryCode) {
                $drpCountry.val(deliveryAddress.countryCode);
            }
        }

        onCountryCodeChanged();

        if ($txbPostalCode && $txbPostalCode.length > 0) {
            addPostCodeChangeListeners();
            updatePostalCodeUi(true);
        }

        if ($drpReferralName && $drpReferralName.length > 0) {
            w.initReferrals($drpReferralGroup, $drpReferralName);

            $drpReferralName.change(function() {
                var referralExtraFields = getReferralExtraFields();
                checkoutController.setExtraFields(referralExtraFields);
            });
        }

        if (ctx.cartEmpty) {
            $container.hide();
            error(ctx.cartEmptyMsg, function(notyMsg) { cartEmptyNoty = notyMsg; });
        }

        deliveryOptionsController.setDeliveryAddress(deliveryAddress, deliveryOptionsLoadInitiator.pageLoad);

        estore.subscribe(estore.channels.callback.shopCart, handleCartUpdate);

        function publishPaymentSelectedNotification(selectedPaymentTabIdx) {
            var selectedPaymentId = getPaymentIdByIdx(selectedPaymentTabIdx);
            var selectedCheckout = ctx.checkouts[selectedPaymentId];

            if (selectedCheckout.paymentName) {
                w.reportPaymentOptionSelection(ctx.checkoutStepNumber, selectedCheckout.paymentName);
            }
        }
    };

    var setNoPaymentAvailable = function () {
        var noPaymentOptionsAvailableMsg = 'No payment option available';
        checkoutController.selectCheckout(null);
        console.error(noPaymentOptionsAvailableMsg);
        w.PubSub.publish('notification', { type: 'error', timeout: 60 * 1000, text: noPaymentOptionsAvailableMsg });
        $container.empty();
        setCountryCodeCookie(null);
        setPaymentIdxCookie(null);
    };
    var getSelectedPaymentId = function (activeTabIdx) {
        var selectedPaymentPanelIdx = typeof activeTabIdx !== 'undefined' ? activeTabIdx : getSelectedPaymentIdx();

        selectedPaymentPanelIdx = parseInt(selectedPaymentPanelIdx);

        return getPaymentIdByIdx(selectedPaymentPanelIdx);
    };
    var getPaymentIdByIdx = function (paymentIdx) {
        var contId = $liPaymentTabHeaders.eq(paymentIdx).find('a').attr('href');
        return $divPaymentContainer.find(contId).data(paymentIdDataKey);
    };
    var getPaymentIdxById = function (paymentId) {
        var index = null;
        $liPaymentTabHeaders.each(function(i) {
            var contId = $(this).find('a').attr('href');
            var currentPaymentId = $divPaymentContainer.find(contId).data(paymentIdDataKey);
            if (currentPaymentId === paymentId) {
                index = i;
                return false;
            }
            return true;
        });
        return index;
    }
    var hidePaymentPanelIfDeliveryDateIsMissing = function () {
        if (selectedDeliveryId >= 0 && isDateRequiredBySelectedDelivery && $txbDeliveryDate.length === 1 && !$txbDeliveryDate.val()) {
            $divPaymentContainer.hide();
        }
    };

    var onPostalCodeChanged = function(updateInput, callback) {
        setPostalCodeCookie(deliveryAddress.postalCode);

        var $postalCodeLnk = $('.js-postal-code-lnk');
        if ($postalCodeLnk.length) {
            var lnkText = $postalCodeLnk.text();
            var delimiterIndex = lnkText.indexOf(':');
            if (delimiterIndex) {
                lnkText = lnkText.slice(0, delimiterIndex);
            }
            $postalCodeLnk.text(lnkText + ': ' + deliveryAddress.postalCode);
        }

        deliveryAddress.isDeliverable = true;
        block($container);

        $.get(w.R + 'api/checkout/order/isdeliverable?postalCode=' + (deliveryAddress.postalCode || '').trim())
            .done(function(result) {
                if (!result) {
                    w.PubSub.publish('notification', { type: 'error', text: 'Empty result' });
                    console.error('[UMW]: Empty result');
                } else if (result.errorMsg) {
                    w.PubSub.publish('notification', { type: 'error', text: result.errorMsg });
                    console.error('[UMW]: ' + result.errorMsg);
                } else {
                    deliveryAddress.isDeliverable = result.isDeliverable;
                }
            })
            .fail(function(errorResponse) {
                console.error('[UMW]: Failed to check order deliverability', errorResponse);
            })
            .always(function() {
                updatePostalCodeUi(updateInput, callback);
                unblock($container);
            });
    };
    var addPostCodeChangeListeners = function () {
        if ($txbPostalCode.length === 0 || !$txbPostalCode.is(':visible')) {
            return;
        }

        $txbPostalCode.keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
        });

        $txbPostalCode.bind('keyup change refresh', function (e) {
            e.preventDefault();
            var postalCode = $txbPostalCode.val().trim();

            if (!postalCode || postalCode.length < 4) {
                if (postCodeChangeTimer) {
                    w.clearTimeout(postCodeChangeTimer);
                    postCodeChangeTimer = null;
                }
                deliveryAddress.postalCode = deliveryAddress.postalArea = null;
                updatePostalCodeUi(false);
                deliveryOptionsController.setDeliveryAddress(deliveryAddress, deliveryOptionsLoadInitiator.userInput);
            } else if (postalCode !== deliveryAddress.postalCode) {
                if (postCodeChangeTimer) {
                    w.clearTimeout(postCodeChangeTimer);
                }
                if (currentCheckoutSpecifics && currentCheckoutSpecifics.canDisableDeliveryPostalCode === false) {
                    checkoutController.resetOrderInProviderOnNextUpdate();
                }
                postCodeChangeTimer = w.setTimeout(function () {
                    deliveryAddress.postalCode = postalCode;
                    deliveryAddress.postalArea = null;
                    onPostalCodeChanged(false, function () { deliveryOptionsController.setDeliveryAddress(deliveryAddress, deliveryOptionsLoadInitiator.userInput); });
                }, 600);
            }
        });
    };
    var updatePostalCodeUi = function (updateInput, callback) {
        var postalCode = deliveryAddress.postalCode;
        if (updateInput) {
            $txbPostalCode.val(postalCode ? postalCode : '');
        }

        if (!postalCode || postalCode.length < 4) {
            if ($txbPostalCode && $txbPostalCode.length > 0) {
                $txbPostalCode.focus();
                $divWritePostalCodeMsg.show();
                $divUndeliverableProdsMsg.hide();
            }
            $lbPostalArea.text('');
        } else if (!deliveryAddress.isDeliverable) {
            $divWritePostalCodeMsg.hide();
            $divUndeliverableProdsMsg.show();
        } else {
            if (deliveryAddress.postalArea) {
                $lbPostalArea.text(deliveryAddress.postalArea);
            } else {
                loadPostalArea(callback);
                callback = null;
            }
            $divWritePostalCodeMsg.hide();
            $divUndeliverableProdsMsg.hide();
        }

        if (callback && typeof callback === 'function') {
             callback();
        }
    };
    var loadPostalArea = function (callback) {
        if (deliveryAddress.countryCode === 'NO') {
            $.getPostalCodeInfo(deliveryAddress.postalCode,
                function (data) {
                    var postalArea = data.valid === true ? data.result : null;
                    deliveryAddress.postalArea = postalArea;
                    $lbPostalArea.text(postalArea ? '(' + postalArea + ')' : '');
                    if (callback) {
                        callback();
                    }
                });
        } else {
            deliveryAddress.postalArea = null;
            $lbPostalArea.text('');
            if (callback) {
                callback();
            }
        }
    }

    var onCountryCodeChanged = function () {
        var countryCode = deliveryAddress.countryCode;

        setCountryCodeCookie(countryCode);

        var i, selectedCheckoutIdx = getSelectedPaymentIdx();
        var fistSupportedCheckoutIdx = -1, isSelectedAvailable = false, unavailableCheckoutIndexes = [];
        for (i = 0; i < checkoutsCount; i++) {
            var paymentId = getPaymentIdByIdx(i);
            var supportedCountries = ctx.checkouts[paymentId].supportedCountries;
            var isPaymentSupported = supportedCountries.indexOf(countryCode) >= 0;
            if (isPaymentSupported) {
                if (i === selectedCheckoutIdx) {
                    isSelectedAvailable = true;
                }
                if (fistSupportedCheckoutIdx < 0) {
                    fistSupportedCheckoutIdx = i;
                }
            } else {
                unavailableCheckoutIndexes.push(i);
            }
        }

        if (fistSupportedCheckoutIdx < 0) {
            setNoPaymentAvailable();
            return;
        }

        // JQuery UI Tabs does not allow to select disabled tab and to disable selected tab.
        // This causes some issues, so while playing with tabs states and selection activate all tabs
        $divPaymentContainer.tabs('enable');

        if (!isSelectedAvailable) {
            $divPaymentContainer.tabs('option', 'active', fistSupportedCheckoutIdx);
        }
        for (i = 0; i < unavailableCheckoutIndexes.length; i++) {
            $divPaymentContainer.tabs('disable', unavailableCheckoutIndexes[i]);
        }
    };
    var addCountryChangeListeners = function () {
        if (!$drpCountry || $drpCountry.length === 0 || !$drpCountry.is(':visible')) {
            return;
        }

        $drpCountry.change(function () {
            deliveryAddress.countryCode = this.value;
            deliveryAddress.postalCode = deliveryAddress.postalArea = null;
            deliveryOptionsController.setDeliveryAddress(deliveryAddress, deliveryOptionsLoadInitiator.userInput);
            updatePostalCodeUi(true);
            onCountryCodeChanged();
        });
    };

    var addCommentChangeListeners = function () {
        if ($txbComment.length === 0) {
            return;
        }

        $txbComment.val(cookie('OrderComment'));

        $txbComment.bind('keyup change', function () {
            if (commentChangeTimeout) {
                w.clearTimeout(commentChangeTimeout);
            }

            commentChangeTimeout = w.setTimeout(function () {
                var comment = $txbComment.val();
                cookie('OrderComment', comment);
                checkoutController.setOrderComment(comment);
            }, 500);
        });
    };

    var handleCartUpdate = function (channel, contract) {
        if (contract && contract.result && contract.result.detailedCartInfo) {
            var productCount = contract.result.detailedCartInfo.summary.productCount;
            cartUpdated(productCount);
        } else {
            $.when(estore.getCartInfo(null, true)).then(handleCartInfoContract, handleErrorContract);
        }
    };

    var handleCartInfoContract = function(cartInfoDataContract) {
        var cartInfo = cartInfoDataContract.result.cartInfo;
        var productsInCartCount = cartInfo.productCount;
        cartUpdated(productsInCartCount);
    };

    var handleErrorContract = function (errContract) {
        if (errContract) {
            var errorMessage;
            if (typeof errContract === 'string') {
                errorMessage = errContract;
            } else {
                errorMessage = errContract.result && errContract.result.items[0] ? errContract.result.items[0].message : errContract.message;
            }

            console.error('Failed to get shopping cart information. %s', errorMessage);
        }
    };

    var cartUpdated = function (productCount) {
        if (productCount === 0) {
            $container.hide();
            error(ctx.cartEmptyMsg, function (notyMsg) { cartEmptyNoty = notyMsg; });
        } else {
            if (cartEmptyNoty) { cartEmptyNoty.close(); }
            deliveryOptionsController.reloadDeliveryOptions();
            $container.show();
        }
    };

    var getPostalCodeFromCookie = function () {
        return (cookie('PostalCodeOverride') || '').trim();
    };

    var setPostalCodeCookie = function (postalcode) {
        cookie('PostalCodeOverride', postalcode);
    };

    var getCountryCodeFromCookie = function() {
        return cookie('CountryCode') || '';
    };
    var setCountryCodeCookie = function (countryCode) {
        cookie('CountryCode', countryCode);
    };

    var getReferralExtraFields = function () {
        var extraFields = [];
        if ($drpReferralGroup && $drpReferralGroup.length > 0) {
            extraFields.push({
                Cid: ctx.referralGroupControlID,
                Text: $lblReferralGroup.text().replace(new RegExp("[:]+$"), ""),
                Value: $("option:selected", $drpReferralGroup).text()
            });
        }

        if ($drpReferralName && $drpReferralName.length > 0) {
            extraFields.push({
                Cid: ctx.referralNameControlID,
                Text: $lblReferralName.text().replace(new RegExp("[:]+$"), ""),
                Value: $("option:selected", $drpReferralName).text(),
                ID: $("option:selected", $drpReferralName).val()
            });
        }

        return extraFields;
    };

    var getPaymentIdxFromCookie = function () {
        return cookie('PaymentType') || 0; // First is default
    }
    var setPaymentIdxCookie = function (paymentIdx) {
        cookie('PaymentType', paymentIdx);
    };

    var getSelectedPaymentIdx = function() {
        return $divPaymentContainer.tabs('option', 'active');
    };

    var setDelivery = async function (delivery) {
        if (delivery) {
            selectedDeliveryId = delivery.deliveryID;
            isDateRequiredBySelectedDelivery = delivery.carriageTimeHours > 0 || delivery.requiresDeliveryDate;
        } else {
            selectedDeliveryId = -1;
            isDateRequiredBySelectedDelivery = false;
        }

        if (selectedDeliveryId < 0) {
            $divPaymentContainer.hide();
            $divDeliveryDate.hide();
            $commentCont.hide();

            if ($txbPostalCode.length === 1) {
                $txbPostalCode.prop('disabled', false);
                $divCantChangePostalCodeMsg.hide();
            }

            checkoutController.setDeliveryInfo(deliveryAddress, null, false);

            return;
        }

        cookie('DeliveryID', selectedDeliveryId);

        $divDeliveryDate.show();
        $commentCont.show();

        await handleDeliveryDate(delivery);

        hidePaymentPanelIfDeliveryDateIsMissing();

        // set delivery info only after delivery date is handled
        checkoutController.setDeliveryInfo(deliveryAddress, delivery, isDateRequiredBySelectedDelivery);
    };

    var getDeliveryDate = function () {
        if ($txbDeliveryDate.length === 1) {
            var date = $txbDeliveryDate.datepicker('getDate');
            return date ? date.toISOString() : null;
        }
        return null;
    };

    var error = function (text, callback) {
        // Hide payment if the error has occured
        $divPaymentContainer.hide();

        if (!w.PubSub || !text || text.length === 0) {
            return;
        }

        w.PubSub.publish('notification', { type: 'error', timeout: 60 * 1000, text: text, notyCallback: callback });
    };
    var showPaymentError = function (paymentId, errorMessage)
    {
        var checkout = checkoutSettings.checkouts[paymentId], errorCont = null, uiCont = null;

        if (checkout) {
            errorCont = checkout.$errorCont;
            uiCont = checkout.$uiCont;
        }

        if (errorCont && uiCont) {
            uiCont.hide();
            errorCont.text(errorMessage);
            errorCont.show();
            $divPaymentContainer.show();
        } else {
            error(errorMessage);
        }
    }
    var hidePaymentError = function (paymentId)
    {
        var checkout = checkoutSettings.checkouts[paymentId], errorCont = null, uiCont = null;

        if (checkout) {
            errorCont = checkout.$errorCont;
            uiCont = checkout.$uiCont;
        }

        if (errorCont && uiCont) {
            errorCont.text('');
            errorCont.hide();
            uiCont.show();
            $divPaymentContainer.show();
        }
    }

    var block = function ($elem) {
        if (typeof ($.blockUI) === 'function') {
            blockInterfaceCounter++;
            $elem instanceof $ ? $elem.block(/*{ message: null }*/) : $.blockUI();
        }
    };
    var unblock = function ($elem) {
        if (typeof ($.unblockUI) === 'function') {
            if (--blockInterfaceCounter <= 0) {
                $elem instanceof $ ? $elem.unblock() : $.unblockUI();
            }
        }
    };

    // returns promise that resolves when delivery date is handled
    var handleDeliveryDate = function (selectedDelivery) {
        var promise = $.Deferred();

        if ($txbDeliveryDate.length === 0) {
            promise.resolve();
            return promise;
        }

        if (ctx.showDeliveryDateIfRequiredByDeliveryOption && !isDateRequiredBySelectedDelivery) {
            $divDeliveryDate.hide();
            $txbDeliveryDate.datepicker('setDate', null);
            $txbDeliveryDate.trigger("change");
            promise.resolve();
            return promise;
        }

        w.require(['momentjs-2.10.6/moment-with-locales.min'],
            function(moment) {
                var nearestAvailableDate = moment(selectedDelivery.nearestDeliveryDate).toDate();
                var deliverOnDays = selectedDelivery.deliverOnDays;
                var publicHolidays = selectedDelivery.publicHolidays;
                var currentDatePickerValue = $txbDeliveryDate.datepicker('getDate');

                if (currentDatePickerValue) {
                    if (!isAvailableForDelivery(currentDatePickerValue)) {
                        const date = ctx.autoSetDeliveryDate ? nearestAvailableDate : null;
                        $txbDeliveryDate.datepicker('setDate', date);
                        $txbDeliveryDate.trigger("change");
                    }
                } else if (ctx.autoSetDeliveryDate) {
                    $txbDeliveryDate.datepicker('setDate', nearestAvailableDate);
                    $txbDeliveryDate.trigger("change");
                }

                $txbDeliveryDate.datepicker('option',
                    'beforeShowDay',
                    function(date) {
                        var isDeliverableDate = isAvailableForDelivery(date);
                        return [isDeliverableDate, isDeliverableDate ? 'DeliveryPossible' : 'DeliveryImpossible'];
                    });

                $txbDeliveryDate.datepicker('refresh');

                promise.resolve();

                function isAvailableForDelivery(targetDeliveryDate) {
                    var day = targetDeliveryDate.getDay();
                    var dateWrapper = moment(targetDeliveryDate);

                    var isDeliverableDate = (dateWrapper.isSame(nearestAvailableDate, 'day') || dateWrapper.isAfter(nearestAvailableDate, 'day'))
                        && (deliverOnDays.length === 0 || _.indexOf(deliverOnDays, day) > -1);

                    if (isDeliverableDate && selectedDelivery.doNotDeliverOnPublicHolidays) {
                        isDeliverableDate = !_.some(publicHolidays,
                            function(holiday) {
                                return dateWrapper.isSame(holiday, 'day');
                            });
                    }

                    return isDeliverableDate;
                }
            });

        return promise;
    };
})(window, jQuery, _);